/** @deprecated Import DraftToDevicePackagingConfirmDialog */
export { default } from './DraftToDevicePackagingConfirmDialog';
